import { gql } from '@apollo/client';

export type CurrentUserData = {
  getUser: {
    uId: string;
    uFullName: string;
    uFirstName: string;
    uEmailId: string;
    uLastName: string;
    uRole: {
      rId: string;
      rName: string;
      rRole: string;
    };
    uStatus: string;
    uUserName: string;
  };
};

export type RefreshTokenData = {
  getAccessToken: {
    AccessToken: string;
    RefreshToken: string;
    ExpiresIn: number;
  };
};

export const GET_CURRENT_USER_QUERY = gql`
  query GetUser {
    getUser {
      uId
      uFullName
      uFirstName
      uEmailId
      uLastName
      uRole {
        rId
        rName
        rRole
      }
      uStatus
      uUserName
    }
  }
`;

export const REFRESH_TOKEN_QUERY = gql`
  query getAccessToken($refreshToken: String!) {
    getAccessToken(refreshToken: $refreshToken) {
      AccessToken
      RefreshToken
      ExpiresIn
    }
  }
`;

export type SignOutData = {
  signOut: {
    message: string;
  };
};

export const SIGN_OUT_QUERY = gql`
  query SignOut($refreshToken: String!) {
    signOut(refreshToken: $refreshToken) {
      message
    }
  }
`;

export type AccountExistenceData = {
  getAccountExistence: boolean;
};

export const GET_ACCOUNT_EXISTENCE_QUERY = gql`
  query getAccountExistence($input: String!, $type: String!) {
    getAccountExistence(input: $input, type: $type)
  }
`;
